import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Autoform } from '../components/forms/autoform';
import { CircularProgress, Container, Grid, Paper } from '@mui/material';
import axios from 'axios';
import api from '../hooks/useApi';
import { redirect, useLoaderData, useRevalidator, useSubmit } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import {requirePartnerOrSuperAdmin} from '../auth/guards';

export async function loader({ request, params }) {
    const authResult = await requirePartnerOrSuperAdmin({request, params});
    if (authResult instanceof Response) return authResult;
    const response = await api.get('/api/CreateObjForms/HotelObjDraft/');
    if (!response.data?.id) {
        throw new Response('Сервер не повернув ID чернетки', {status: 502});
    }
    return redirect(`/new-object/draft/${response.data.id}`);
}

export async function action({ request, params }) {
    const authResult = await requirePartnerOrSuperAdmin({request, params});
    if (authResult instanceof Response) return authResult;
    const formData = await request.formData();
    let status, ret_val = {};
    try {
        const response = await api.post('/api/HotelObj/', formData)

        if (response.status === 201 || response.status === 200) {
            status = 'success';
            ret_val = response.data;
        }
        else {
            status = 'unexpected';
        }
    }
    catch (e) {
        status = 'fail';
    }
    return { status: status, newObj: ret_val };
}

export default function NewObject() {
    const formName = 'HotelObj';
    const formLoader = useLoaderData();
    const submit = useSubmit();
    const [form, setForm] = useState(formLoader);
    const formHook = useForm();
    const revalidator = useRevalidator();

    return (
        <Container>
            <PageTitle title="Новий об'єкт" />
            <Grid item xs={8}>
                <Paper>
                    <h2>Додати новий об'єкт</h2>
                    {form ? (
                        
                            <Autoform
                                fields={form}
                                formHook={formHook} // Pass the formHook to AutoForm
                                formName={formName}
                                renderChildForm={true}
                                revalidator={revalidator}
                                className={'newObjectForm'}
                            />
                    ) : (
                        <CircularProgress />
                    )}
                </Paper>
            </Grid>
        </Container>
    )
}
/*import { Button, Box, Card, Typography } from '@mui/material';

const AnotherPage = () => {
    const [showCard, setShowCard] = useState(false);

    const handleShowCard = () => {
        setShowCard(true);
    };
    const buttons = [
        { label: 'Ціна'},
        { label: 'Місто розташування'},
        { label: 'Адреса'},
        { label: 'Власник'},
        { label: 'Класифікація'},
        { label: 'Обмеження'},
        { label: 'Умови'},
        { label: 'Правила'},
        { label: 'Значки'},
    ];

    const handleButtonClick = (label) => {
//console.log((`Button clicked: ${label}`);
    };

    return (
        <div style={{ textAlign: 'center', marginTop: 30 }}>
            <div>
                {buttons.map((button, index) => (
                    <Button
                        key={index}
                        variant="contained"
                        color="primary"
                        onClick={()=>{handleButtonClick(button.label)}}
                        sx={{ m: 1, backgroundColor: '#dcedff', color: 'black', '&:hover':{color:'white'}, elevation: 0 }}
                    >
                        {button.label}
                    </Button>
                ))}
            </div>
            <Button
                variant="contained"
                color="primary"
                onClick={handleShowCard}
                sx={{ mt: 6, textTransform: 'none' }}>
                Додати новий об'єкт
            </Button>
            {showCard && (
                <Box mt={8}>
                    <Card>
                        <Box p={2}>
                            <Typography variant="h5" component="div" gutterBottom>
                                Новий об'єкт "Назва об'єкту" створено
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{
                                    m: 1, backgroundColor: '#dcedff', color: 'black',
                                    '&:hover': {
                                        color: 'white',
                                    }
                                }}
                            >
                                Перейти до його календаря
                            </Button>
                        </Box>
                    </Card>
                </Box>
            )}
        </div>
    );
};

export default AnotherPage;
*/
